<template>
<div class="background">
  <building-search-bar />

  <div class="container main">
    <div class="achor-container">
      <page-anchor class="hidden-xs" :sections="sections"></page-anchor>
    </div>
    <first-medium v-if="media.length > 0 && (media[0].type !== 'Photo')" :medium="media[0]" >
    </first-medium>
    <div id="basic" class="row intro">
      <div class="building-info-section">
        <div class="stock-name zh">{{ buindingObject.nameZh }}</div>
        <div 
          class="stock-name en" 
          v-if="buindingObject.nameZh !== buindingObject.nameEn"
        >
          {{ buindingObject.nameEn }}
        </div>
        <div class="building-address">
          {{ unicornDistrict }} {{ buildingAddress }}
        </div>
        <div class="building-info-group">
          <div class="stock_count">
            <pill v-if="sellInfo.value" :item="sellInfo" class="pill" :pisBuildingId="pisBuildingId"></pill>
            <pill v-if="leaseInfo.value" :item="leaseInfo" class="pill" :pisBuildingId="pisBuildingId"></pill>
          </div>
          <div class="building-desc">
            {{ buildingDesc }}
          </div>
        </div>
      </div>
      <second-medium v-if="secondMedium" :medium="secondMedium">
      </second-medium>
    </div>

    <div class="row gallery-wrapper">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <gallery :media="media" :bgColor="galleryBgColor" :big="largeIconBox" :skip="skipMediaNum"></gallery>
      </div>
    </div>
    
    <div id="buildingInfo" class="row building-info">
      <section-header>
        <span>{{ $t('building_page.buildingInfo') }}</span>
      </section-header>
      <div class="col-xs-12">
        <building-info-box 
          :pisBuildingId="pisBuildingId" 
          :unicornDistrict="unicornDistrict"
          class="building-info-container"
        ></building-info-box>
      </div>
    </div>
    
    <!-- map -->
    <div id="location" class="row">
      <section-header>
        <span>{{ $t('building_page.location') }}</span>
      </section-header>
      <div :class="`col-lg-${building.streetViewUrl ? 6 : 12} col-md-${building.streetViewUrl ? 6 : 12} col-sm-${building.streetViewUrl ? 6 : 12} col-xs-12 no-pad`">
        <static-map v-if="coordinate && coordinate.lat && coordinate.lng" 
          :lat="parseFloat(coordinate.lat)" 
          :lng="parseFloat(coordinate.lng)"
          :buildingName="buildingName"
          :pinScale="mapPinScale">
          </static-map>
      </div>
    
      <div v-if="building && building.streetViewUrl" class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-pad">
        <google-map-street-view :pisBuildingId="pisBuildingId"></google-map-street-view>
      </div>
    </div>
    
    <!-- transaction -->
    <div id="transaction" class="transaction-section row">
      <section-header>
        <span>{{ $t('building_page.TX_TITLE') }}</span>
      </section-header>
      <div class="col-lg-12 col-md-12 col-md-12 col-xs-12 pad-top pad-bottom">
        <div class="row">
          <div class="col-xs-12 pad-top">
            <transaction-chart :buildingId="pisBuildingId" :ics="buildingSbu" @txChanged="txChanged(...arguments)"></transaction-chart>
          </div>  
          <div class="col-xs-12 pad-top">
            <transaction 
            :buildingName="buildingName"
            :pisBuildingId="pisBuildingId"
            :streetId="extraInfo.street_id"
            :themeColor="themeColor"
            :ics="buildingSbu"
            :txType="txType">
            </transaction>
          </div>
        </div>      
      </div>
    </div>

    <div id="news" class="row news-section">
      <section-header>
        <span>{{ $t('building_page.NEWS_TITLE') }}</span>
      </section-header>
      <div class="col-xs-12 pad-bottom">
        <news-box :keyword="keyword" :themeColor="themeColor"></news-box>
      </div>
    </div>
    
    <div id="share" class="row">
      <share-to-platform></share-to-platform>
    </div>
    
    <div class="row suggested-stock-section">
      <suggested-stock />
    </div>

  </div>
</div>
</template>

<script>
import gql from 'graphql-tag';
import inView from 'in-view';
import buildingInfo from '@/api/building';
import BuildingSearchBar from '@/components/Building/SearchBar';
import SectionHeader from '@/components/StockDetails/SectionHeader';
import PageAnchor from '@/components/PageAnchor';
import LoadingBox from '@/components/LoadingBox';
import TabPanel from '@/components/TabPanel';
import Pill from '@/components/Pill';
import Gallery from '@/components/Gallery';
import NewsBox from '@/components/NewsBox';
import StaticMap from '@/components/StaticMap';
import GoogleMapStreetView from '@/components/GoogleMapStreetView';
import Transaction from '@/components/Transaction';
import TransactionChart from '@/components/TransactionChart';
import StockVideo from '@/components/StockDetails/StockVideo';
import BuildingInfoBox from '@/components/Building/BuildingInfo';
import ShareToPlatform from '@/components/ShareToPlatform';
import SuggestedStock from '@/components/Stock/SuggestedStock';
import FirstMedium from '@/components/FirstMedium';
import SecondMedium from '@/components/SecondMedium';

import txIcon from '@/assets/icons/icon_Tx.svg';
import titleIcon from '@/assets/icons/icon_ExtraInfo.svg';
import newsIcon from '@/assets/icons/icon_News.svg';
import floorIcon from '@/assets/icons/icon_Structure.svg';

export default {
  components: {
    BuildingSearchBar,
    LoadingBox,
    TabPanel,
    Pill,
    SectionHeader,
    PageAnchor,
    NewsBox,
    StaticMap,
    GoogleMapStreetView,
    Transaction,
    TransactionChart,
    Gallery,
    StockVideo,
    BuildingInfoBox,
    ShareToPlatform,
    SuggestedStock,
    FirstMedium,
    SecondMedium
  },
  data() {
    return {
      districtId: null,
      buildings: null,
      sections: [
        { name: 'basic', active: false },
        { name: 'buildingInfo', active: false },
        { name: 'location', active: false },
        { name: 'transaction', active: false },
        { name: 'news', active: false },
      ],
      titleIcon,
      txIcon,
      newsIcon,
      floorIcon,
      building: {},
      pisBuilding: {
        unicornBuildings: [],
      },
      galleryBgColor: '#515151',
      txType: 'S',
      extraInfo: {},
    };
  },
  mounted() {
    this.streetId();
    this.sections.forEach((sec, idx) => {
      inView.threshold(0.5);
      inView(`#${sec.name}`)
        .on('enter', () => {
          this.sections.forEach((_, i) => { this.sections[i].active = false; });
          this.sections[idx].active = true;
        });
    });
    
    if (this.$i18n.locale === 'gb') {
      window.changeToGb();
    }
  },
  computed: {
    currentPage() {
      return this.$route.name;
    },
    buildingSbu() {
      switch (this.building.sbu) {
        case 'mr_ind':
          return 'i';
        case 'mr_comm':
          return 'c';
        case 'mr_shop':
          return 's';
        default:
          return 'c';
      }
    },
    themeColor() {
      if (this.buildingSbu === 'i') {
        return '#47337C';
      }
      if (this.buildingSbu === 'c') {
        return '#008cba';
      }
      return '#da4e00';
    },
    buildingName() {
      let buildingObject = null;
      let buildingName = '';

      if (Array.isArray(this.pisBuilding.unicornBuildings)) {
        const unicornBuilding = this.pisBuilding.unicornBuildings.find(
          ub => ub.ics_type === this.buildingSbu);
        if (unicornBuilding) {
          buildingObject = {
            nameEn: unicornBuilding.name_en,
            nameZh: unicornBuilding.name_zh,
          };
        }
      }
      if (!buildingObject) {
        buildingObject = this.building;
      }

      if (window.lang === 'english') {
        buildingName = buildingObject.nameEn || '';
      } else {
        buildingName = buildingObject.nameZh || '';
      }

      document.title = `${buildingName} - ${this.$t('building_page.BLDG_PAGE')}`;

      return buildingName;
    },
    buindingObject() {
      let buildingObject = null;

      if (Array.isArray(this.pisBuilding.unicornBuildings)) {
        const unicornBuilding = this.pisBuilding.unicornBuildings.find(
          ub => ub.ics_type === this.buildingSbu);
        if (unicornBuilding) {
          buildingObject = {
            nameEn: unicornBuilding.name_en,
            nameZh: unicornBuilding.name_zh,
          };
        }
      }
      if (!buildingObject) {
        buildingObject = this.building;
      }

      return buildingObject;
    },
    buildingAddress() {
      if (window.lang === 'english') {
        return this.building.addressEn ? this.building.addressEn : '';
      }
      return this.building.addressZh ? this.building.addressZh : '';
    },
    buildingDesc() {
      if (window.lang === 'english') {
        return this.building.descriptionEn ? this.building.descriptionEn : '';
      }
      return this.building.descriptionZh ? this.building.descriptionZh : '';
    },
    unicornDistrict() {
      let buildingObject = null;
      let unicornDistrict = null;

      if (Array.isArray(this.pisBuilding.unicornBuildings)) {
        const unicornBuilding = this.pisBuilding.unicornBuildings.find(
          ub => ub.ics_type === this.buildingSbu);
        if (unicornBuilding) {
          buildingObject = {
            district: unicornBuilding.district,
          };
        }
      }
      if (buildingObject && buildingObject.district) {
        if (window.lang === 'english') {
          unicornDistrict = buildingObject.district.name_en || null;
        } else {
          unicornDistrict = buildingObject.district.name_zh || null;
        }
      }
      return unicornDistrict;
    },
    estateName() {
      if (window.lang === 'english') {
        return this.pisBuilding.estate_name_en ? this.pisBuilding.estate_name_en : '';
      }
      return this.pisBuilding.estate_name_zh ? this.pisBuilding.estate_name_zh : '';
    },
    keyword() {
      return this.pisBuilding.estate_name_zh ?
             this.pisBuilding.estate_name_zh : this.building.nameZh;
    },
    media(){
      let tmpMedia = [];
      if(Array.isArray(this.building.media) && (this.videoC || this.videoI)) {
        this.building.media.forEach((m) => {
          const mediumC = this.videoC ? this.videoC.find((ele) => ele.id.toString().trim() === m.id.toString().trim()) : null;
          const mediumI = this.videoI ? this.videoI.find((ele) => ele.id.toString().trim() === m.id.toString().trim()) : null;
          const mediumS = this.videoS ? this.videoS.find((ele) => ele.id.toString().trim() === m.id.toString().trim()) : null;

          if(mediumC){
            if(m.__typename === 'Vr'){
              tmpMedia.push({"type": 'Vr', "script": mediumC.script, "thumbnail": mediumC.thumbnail, "id": mediumC.id, "ics": "c", "buildingId": this.pisBuildingId});
            } else if (m.__typename === 'Photo'){
              tmpMedia.push({"type": 'Photo', "src":mediumC.mediumRoot, "id": mediumC.id });
            } else if (m.__typename === 'Video' && mediumC.youtubeMrId) {
              tmpMedia.push({"type": 'Video', "youtubeMrId": mediumC.youtubeMrId, "id": mediumC.id });
            }
          }
          
          if(mediumI){
            if(m.__typename === 'Vr'){
              tmpMedia.push({"type": 'Vr', "script": mediumI.script, "thumbnail": mediumI.thumbnail, "id": mediumI.id, "ics": "i", "buildingId": this.pisBuildingId});
            } else if (m.__typename === 'Photo'){
              tmpMedia.push({"type": 'Photo', "src": mediumI.mediumRoot, "id": mediumI.id});
            } else if (m.__typename === 'Video' && mediumI.youtubeMrId) {
              tmpMedia.push({"type": 'Video', "youtubeMrId": mediumI.youtubeMrId, "id": mediumI.id});
            }
          }

          if(mediumS){
            if(m.__typename === 'Vr'){
              tmpMedia.push({"type": 'Vr', "script": mediumS.script, "thumbnail": mediumS.thumbnail, "id": mediumS.id, "ics": "i", "buildingId": this.pisBuildingId});
            } else if (m.__typename === 'Photo'){
              tmpMedia.push({"type": 'Photo', "src": mediumS.mediumRoot, "id": mediumS.id});
            } else if (m.__typename === 'Video' && mediumS.youtubeMrId) {
              tmpMedia.push({"type": 'Video', "youtubeMrId": mediumS.youtubeMrId, "id": mediumS.id});
            }
          }
          
        });
      }      
      return tmpMedia;
    },
    mediaCIds() {
      return Array.isArray(this.building.media) ?
        this.building.media.reduce((ids, media) => {
          if (media.sbu === 'MR_COMM') {
            ids.push(media.id);
          }
          return ids;
        }, []) :
        [];
    },
    mediaIIds() {
      return Array.isArray(this.building.media) ?
        this.building.media.reduce((ids, media) => {
          if (media.sbu === 'MR_IND') {
            ids.push(media.id);
          }          
          return ids;
        }, []) :
        [];
    },
    mediaSIds() {
      return Array.isArray(this.building.media)
        ? this.building.media.reduce((ids, media) => {
            if (media.sbu === 'MR_SHOP') {
              ids.push(media.id);
            }
            return ids;
          }, [])
        : [];
    },
    secondMedium() {
      let m = null
      if (this.media && Array.isArray(this.media)) {
        if (this.media[0] && this.media[0].type === 'Photo') {
          m = this.media[0];
        } else if (this.media.length > 1) {
          m = this.media[1];
        }
      }
      return m;
    },
    skipMediaNum() {
      let n = 1;
      if (this.media && Array.isArray(this.media)) {
        if (this.media[0] && this.media[0].type === 'Photo') {
          n = 1;
        } else if (this.media.length > 1) {
          n = 2;
        }
      }      
      return n;
    },
    pisBuildingId() {
      return this.$route.params.id;
    },
    buildingCommId() {
      const found = this.pisBuilding.unicornBuildings.find(blg => blg.company === 'mr' && blg.ics_type === 'c');
      return found ? found.id : '';
    },
    buildingIndId() {
      const found = this.pisBuilding.unicornBuildings.find(blg => blg.company === 'mr' && blg.ics_type === 'i');
      return found ? found.id : '';
    },
    buildingShopId() {
      const found = this.pisBuilding.unicornBuildings.find(blg => blg.company === 'mr' && blg.ics_type === 's');
      return found ? found.id : '';
    },
    coordinate() {
      if (Array.isArray(this.pisBuilding.unicornBuildings)) {
        const unicornBuilding = this.pisBuilding.unicornBuildings.find(
          ub => ub.ics_type === this.buildingSbu);
        if (unicornBuilding && unicornBuilding.coordinate) {
          return unicornBuilding.coordinate;
        }
      }

      if (this.building.streetViewUrl) {
        const urlRegex = /\/@([-0-9.]+),([-0-9.]+),/;
        const match = urlRegex.exec(this.building.streetViewUrl);
        if (match) {
          return {
            lat: match[1],
            lng: match[2],
          };
        }
      }

      return null;
    },
    sellInfo() {
      let value = 0;
      if (this.pisBuilding.stockCount) {
        value = this.pisBuilding.stockCount.saleCount;
      }
      return {
        type: 'sell',
        value,
      };
    },
    leaseInfo() {
      let value = 0;
      if (this.pisBuilding.stockCount) {
        value = this.pisBuilding.stockCount.leaseCount;
      }
      return {
        type: 'lease',
        value,
      };
    },
    largeIconBox() {
      if (!this.$md.mobile() || this.$md.tablet()) {
        return false;
      }
      return true;
    },
    mapPinScale() {
      if ((this.$md.mobile() && !this.$md.tablet()) || this.building.streetViewUrl) {
        return 1;
      }
      return 2;
    }
  },
  methods: {
    streetId() {
      const data = {
        ics_type: 's',
        pis_bldg_id: this.pisBuildingId,
      };

      buildingInfo.getStreetIdByPisBuildingId({
        ...data,
      })
      .then((info) => {
        this.extraInfo = info;
      });
    },
    txChanged(value) {
      this.txType = value;
    },
    photoTypeSortKey(type) {
      const sortMap = {
        layout: 0,
        interior: 1,
        lobby: 2,
        entrance: 3,
        lift: 4,
        plan: 999,
      };
      return type in sortMap ? sortMap[type] : 5;
    },
  },
  watch: {
    building() {
      this.$nextTick(() => {
        if (this.$i18n.locale === 'gb') {
          window.changeToGb();
        }
      });
    },
    buildingObject() {
      this.$nextTick(() => {
        if (this.$i18n.locale === 'gb') {
          window.changeToGb();
        }
      });
    },
    pisBuilding() {
      this.$nextTick(() => {
        if (this.$i18n.locale === 'gb') {
          window.changeToGb();
        }
      });
    },
    pisBuildingId() {
      this.$nextTick(() => {
        if (this.$i18n.locale === 'gb') {
          window.changeToGb();
        }
      });
    },
  },
  apollo: {
    videoC: {
      client: 'mediaC',
      fetchPolicy: 'network-only',
      query: gql`
        query($mediaIds: [ID]) {
          media(ids: $mediaIds){
            id
            ...on Photo{
              mediumRoot
            }
            ...on Video{
              youtubeMrId
            }
            ...on EmbeddedScript{
              script
              thumbnail
            }
          }
        }
      `,
      update: data => data.media,
      variables() {
        return { mediaIds: this.mediaCIds };
      },
    },
    videoI: {
      client: 'mediaI',
      fetchPolicy: 'network-only',
      query: gql`
        query($mediaIds: [ID]) {
          media(ids: $mediaIds){
            id
            ...on Photo{
              mediumRoot
            }
            ...on Video{
              youtubeMrId
            }
            ...on EmbeddedScript{
              script
              thumbnail
            }
          }
        }
      `,
      update: data => data.media,
      variables() {
        return { mediaIds: this.mediaIIds };
      },
    },
    videoS: {
      client: 'mediaS',
      fetchPolicy: 'network-only',
      query: gql`
        query($mediaIds: [ID]) {
          media(ids: $mediaIds) {
            id
            ... on Photo {
              mediumRoot
            }
            ... on Video {
              youtubeMrId
            }
            ... on EmbeddedScript {
              script
              thumbnail
            }
          }
        }
      `,
      update: data => data.media,
      variables() {
        return { mediaIds: this.mediaSIds };
      },
    },
    building: {
      client: 'building',
      fetchPolicy: 'network-only',
      query: gql`
        query ($pisBuildingId: ID!) {
          building(id: $pisBuildingId) {
            id
            nameZh
            nameEn
            addressEn
            addressZh
            descriptionZh
            descriptionEn
            sbu
            streetViewUrl
            media {
              id
              sbu
              ... on Photo {
                mediumRoot
              }
              ... on Video {
                mediumRoot
              }
            }
          }
        }
      `,
      variables() {
        return { pisBuildingId: this.pisBuildingId };
      },
    },
    pisBuilding: {
      client: 'api',
      fetchPolicy: 'network-only',
      query: gql`
        query ($pisBuildingId: ID!) {
          pisBuilding(id: $pisBuildingId) {
            id
            estate_name_zh
            estate_name_en
            stockCount {
              saleCount
              leaseCount
            }
            unicornBuildings {
              id
              company
              ics_type
              name_zh
              name_en
              district {
                name_zh
                name_en
              }
              coordinate {
                lat
                lng
              }
            }
          }
        } 
      `,
      variables() {
        return { pisBuildingId: this.pisBuildingId };
      },
      skip() {
        return !this.pisBuildingId;
      },
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
}

.achor-container {
  position: absolute;
}

.building-info-section {
  flex: 1 1 50%;
  padding: 10px 15px 0 15px;
}

.stock-name {
  font-weight: 700;
  color: #FFFFFF;
}

.stock-name.zh {
  font-size: 32.2px;
  line-height: 1;
}

.stock-name.en {
  font-size: 18.2px;
}

.intro {
  background-color: #343434;
  color: #fff;
  display: flex;
}

.main-info {
  flex: 1 1 auto;
}

.desc {
  line-height: 30px;
  margin-bottom: 5px;
}

.pill {
  margin: 0px 20px 0px 0px;
}

.building-address {
  font-size: 19.6px;
  margin: 10px 0;
}

.stock_count {
  margin: 20px 0;
}

.info-section, .transaction-section {
  background-color: #FFFFFF;
}

.news-section {
  background-color: #FFFFFF;
}

.title_block { margin-bottom: 10px; }

.building-name { 
  font-size: 35px; 
  font-weight: 700;
  display: inline-block; 
  line-height: 50px; 
  margin-top: 10px;
}

.building-desc {
  font-size: 18px;
  line-height: 28px;
}

.gallery-wrapper {
  background-color: #515151;
}

.gallery-wrapper > div {
  padding: 0;
}

.building-info {
  background-color: #e6e6e6;
}

.floor-directory-container { 
  width: 60%;
  margin: 20px auto; 
  height: 350px;
}

.pad-top {
  padding-top: 28px;
}
.pad-bottom {
  padding-bottom: 56px;
}

.no-pad {
  padding: 0;
}

.building-info-container {
  text-align: center;
  padding-bottom: 56px;
}

.suggested-stock-section {
  padding: 20px 0;
}

.building-info-group {
  display: flex;
  flex-flow: column;
}

.background {
  background: #F5F5F5;
}

@media (max-width: 812px) { 
  .flex-wrap {
    flex-wrap: wrap;
  }
  
  .intro {
    flex-flow: column;
  }
  
  .intro .building-info-section {
    text-align: center;
    padding-bottom: 10px;
  }
  
  .building-info-group {
    flex-direction: column-reverse;
  }
}

@media screen and (min-width:768px) {
  .stock-name-container {
    display: flex;
    justify-content: center;
  }
}

@media screen and (min-width:992px) {
  .stock-name {
    font-size: 25.2px;
  }
}

@media screen and (min-width:768px) and (max-width:812px) {
  .achor-container {
    right: 0.5%;
  }
}

@media screen and (min-width:813px) and (max-width:991px) {
  .achor-container {
    right: -1%;
  }
}

@media screen and (min-width:992px) and (max-width:1279px) {
  .achor-container {
    right: 0.5%;
  }
}

@media screen and (min-width:1280px) {
  .achor-container {
    right: -0.5%;
  }
}
</style>
